import React from 'react'
import { HistoryProps } from './types'
import HistoryItem from './HistoryItem'

const History: React.FC<HistoryProps> = ({ items, children }) => {
  return (
    <>
      <ul>{items.map(HistoryItem)}</ul>
      {children}
    </>
  )
}

export default History
